import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import './home-main.css';
import { debug } from './../../utils';
const HomeDev = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  return (
    <div id="home-dev">
      <div className="page-title">
        <h1>&nbsp;</h1>
      </div >
      <div className='row'>
        <div className='col-sm-6'>
          <h2>Shortcuts front </h2>
          <div className="container py-5 text-center">
            <Link to="/formalities/request/creation-sarl-eurl/1-0-0" className="btn btn-lg btn-green">creation-sarl-eurl</Link>
          </div>
        </div>
        <div className='col-sm-6'>
          <h2>Shortcuts admin </h2>
          <div className="container py-5 text-center">
            <Link to="/admin/formalities" className="btn btn-lg btn-green">liste des formalites</Link>
          </div>
        </div>
      </div>
      <hr />
    </div >
  );
};
export default HomeDev;
